/* Camera colour -> existing product gallery. No variant, price or cart writes. */
(function () {
  'use strict';
  if (window.SmarketColourMedia) return;
  var galleries = [];
  function colourOf(snapshot) {
    if (!snapshot || !snapshot.available || !Array.isArray(snapshot.groups) || !snapshot.groups.length) return '';
    var colours = snapshot.groups.map(function (group) { return String(group.colour).trim().toLowerCase(); });
    return colours.every(function (colour) { return colour === colours[0]; }) ? colours[0] : '';
  }
  function sync(entry, snapshot) {
    if (!entry.node.isConnected || !snapshot || snapshot.productId !== entry.config.productId) return;
    var colour = colourOf(snapshot);
    var groups = snapshot.available && Array.isArray(snapshot.groups) ? snapshot.groups : [];
    var key = groups.map(function (group) { return String(group.colour).trim().toLowerCase(); }).join('|');
    var combos = entry.config.combinations;
    var combination = combos && combos.models && combos.images && groups.length === combos.models.length &&
      groups.every(function (group, i) {
        return Array.isArray(combos.models[i]) && combos.models[i].indexOf(group.model) !== -1;
      });
    var choice = combination ? key : colour;
    if (entry.colour === choice) return;
    var id = combination ? combos.images[key] : entry.config.media[colour];
    if (!id) { entry.colour = choice; return; }
    var section = document.getElementById(entry.config.sectionId);
    var gallery = section && section.querySelector('sht-prd-slideshow');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    var target = entry.config.sectionId + '-' + id;
    var thumb = Array.from(gallery.querySelectorAll('.js-slideshow-btn-thumb')).find(function (button) {
      return button.dataset.target === target;
    });
    // A stale/missing image reference must never break the product form.
    var slide = Array.from(gallery.querySelectorAll('.js-product-slideshow-item')).find(function (item) {
      return item.dataset.mediaId === target;
    });
    if (!thumb || !slide) { entry.colour = choice; return; }
    gallery.setActiveMedia(thumb);
    entry.colour = choice;
  }
  function init() {
    galleries = galleries.filter(function (entry) { return entry.node.isConnected; });
    document.querySelectorAll('[data-smk-colour-media]').forEach(function (node) {
      if (galleries.some(function (entry) { return entry.node === node; })) return;
      try {
        var config = JSON.parse(node.textContent);
        if (config.productId && config.sectionId && config.media) galleries.push({node:node,config:config});
      } catch (error) { console.warn('Invalid camera colour media configuration', error); }
    });
    var options = window.SmarketCameraOptions;
    if (options && options.selection) galleries.forEach(function (entry) { sync(entry, options.selection(entry.config.productId)); });
  }
  window.SmarketColourMedia = { init: init };
  document.addEventListener('smk:camera-selection-change', function (event) {
    galleries.forEach(function (entry) { sync(entry, event.detail); });
  });
  document.addEventListener('shopify:section:load', init);
  Promise.all(['smk-camera-options', 'sht-prd-slideshow'].map(function (tag) {
    return customElements.whenDefined(tag);
  })).then(function () {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
    else init();
  });
})();
